import { STR } from "../i18n.js";
import { useStore } from "../store.js";
import { Field, NumberField, Panel } from "./ui-primitives.js";

export function TankSettings() {
  const { sac, tankVolume, tankStartPressure, lang, setTank } = useStore();
  const t = STR[lang];

  return (
    <Panel title={t.tank}>
      <div className="field-row">
        <Field label={t.tank_vol}>
          <NumberField
            value={tankVolume}
            min={1}
            max={30}
            step={1}
            suffix="L"
            onChange={(v) => setTank(sac, v, tankStartPressure)}
          />
        </Field>
        <Field label={t.tank_p}>
          <NumberField
            value={tankStartPressure}
            min={50}
            max={300}
            step={10}
            suffix="bar"
            onChange={(v) => setTank(sac, tankVolume, v)}
          />
        </Field>
      </div>
      <div style={{ height: 8 }} />
      <Field label={t.sac}>
        <NumberField
          value={sac}
          min={5}
          max={50}
          step={1}
          suffix="L/min"
          onChange={(v) => setTank(v, tankVolume, tankStartPressure)}
        />
      </Field>
    </Panel>
  );
}
